// ================================
// 1. Reusable Feature Component
// ================================

import React from "react";
import { Row, Col } from "react-bootstrap";
import SlideIn from "./SlideIn";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faSmile } from "@fortawesome/free-solid-svg-icons";
import { Button } from "react-bootstrap";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";


function FeatureLanding({ title, description, img, reverse = false, call_to_action = false }) {

    const { t } = useTranslation();
  return (
    <SlideIn>
      <Row
        className={`align-items-center my-4 py-3 ${
          reverse ? "flex-md-row-reverse" : ""
        }`}
      >
        <Col md={6} className={reverse ? "ps-md-5" : "pe-md-5"}>
          <div style={{ width: "40px", height: "4px", backgroundColor: "#0f3460", borderRadius: "2px", marginBottom: "12px" }} />
          <h2 className="mb-3">{title}</h2>
          <p className="text-secondary fs-5">{description}</p>
          {call_to_action && (
            <Button as={Link} to="/login" size="lg" className="landing-page-btn mb-3">
              {t("cta.start_btn")}
            </Button>
          )}
        </Col>

        <Col md={6} className="d-flex justify-content-center">
          <img
            src={img}
            alt={title}
            className="img-fluid rounded shadow-lg"
            style={{
              maxHeight: "400px", // adjust as needed
              objectFit: "cover", // ensures it scales nicely
            //   width: "100%", // keeps it responsive
            }}
          />
        </Col>
      </Row>
    </SlideIn>
  );
}

export default FeatureLanding;
